<template>
  <div class="page-add">
    <div class="add-title">
      新增期刊
    </div>
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      :rules="rules"
      label-width="100px"
      size="small"
      class="form"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="期刊名称：" prop="periodicalName">
            <el-input
              placeholder="请输入期刊名称"
              v-model="ruleForm.periodicalName"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="期刊来源：" prop="periodicalSource">
            <el-input
              placeholder="请输入期刊来源"
              v-model="ruleForm.periodicalSource"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            class="scale"
            label="配图："
            prop="coverUrl"
            :rules="{
              required: true,
              message: '请上传图片'
            }"
            :show-message="showError"
          >
            <av-preview
              v-if="ruleForm.coverUrl"
              :src="ruleForm.coverUrl"
              type="image"
              @delete="deleteCover"
            />
            <upload
              v-else
              :draggable="false"
              :path="'periodical/img'"
              type="image"
              v-model="ruleForm.covers"
            />
            <div class="upload_tip">
              <div class="img_tip">建议尺寸：315px*420px（或3:4）</div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="排序：" prop="order">
        <el-input-number v-model="ruleForm.order" :min="0"></el-input-number>
      </el-form-item>
      <el-form-item label-width="0" class="center">
        <el-button size="small" @click="reset">重置</el-button>
        <el-button size="small" type="primary" @click="onSubmit"
          >提交</el-button
        >
        <back-button :pathOptions="pathOptions" :floatLeft="false" />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { Confirm } from "@/components/Confirm";
import Upload from "@/components/upload/index";
import AvPreview from "@/components/av-preview/index";
import { periodicalInfoSave } from "@/api/periodicalInfo";
import { setItem } from "@/utils/storage.js";
import BackButton from "@/components/backButton/index.vue";

export default {
  components: { Upload, AvPreview, BackButton },
  data() {
    return {
      pathOptions: {
        path: "/periodicalInfo",
      },
      ruleForm: {
        periodicalName: "",
        periodicalSource: "",
        coverUrl: "",
        order: 0,
        covers: []
      },
      showError: false,
      rules: {
        periodicalName: [
          {
            required: true,
            message: "请输入期刊名称",
            trigger: ["blur", "change"]
          }
        ],
        periodicalSource: [
          {
            required: true,
            message: "请输入期刊来源",
            trigger: ["blur", "change"]
          }
        ]
      }
    };
  },
  watch: {
    "ruleForm.covers": {
      handler(val) {
        if (val.length > 0) {
          this.ruleForm.coverUrl = val[0].url;
          this.showError = false;
        } else {
          this.ruleForm.coverUrl = "";
          this.showError = true;
        }
      }
    }
  },
  methods: {
    // 删除封面
    deleteCover() {
      // 清空已上传的文件列表
      this.ruleForm.covers = [];
    },
    onSubmit() {
      this.$refs["ruleForm"].validate().then(() => {
        if (!this.ruleForm.coverUrl) {
          this.showError = true;
          return;
        }
        let params = { ...this.ruleForm, onlineStatus: 0 };
        delete params.covers;
        periodicalInfoSave(params).then(res => {
          if (!res || res.code != 0) return;
          this.$message.success(res.msg);
          setItem(this.REFRESH_FLAG, true);
          this.$router.back();
        });
      });
    },
    reset() {
      const text = "确定重置吗?";
      Confirm(text, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$refs["ruleForm"].resetFields();
        this.ruleForm.covers = [];
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.center {
  margin-top: 20px !important;
  text-align: center;
}
</style>
